import * as Yup from "yup";

// eslint-disable-next-line no-useless-escape
const phoneRegex = /^[0-9]*$/;

const signupSchema = Yup.object({
  email: Yup.string().required("Required").email("Invalid email address"),
  fullName: Yup.string().required("Required"),
  phoneNo: Yup.string()
    .required("Required")
    .matches(phoneRegex, "Invalid phone number")
    .length(10, "Invalid phone number"),
  company: Yup.string().trim().required("Required"),
  jobTitle: Yup.string().trim().required("Required"),
  notes: Yup.string().optional(),
});
export default signupSchema;
